document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hotspot-looks-section').forEach(initHotspotLooks);
});

document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.hotspot-looks-section');
  if (section) initHotspotLooks(section);
});

function initHotspotLooks(section) {
  const wrapper = section.querySelector('.hotspot-looks-wrapper');
  if (!wrapper) return;

  const track = section.querySelector('.hotspot-looks-track');
  const cols = parseInt(wrapper.dataset.columns || '2', 10);
  const isCarousel = wrapper.dataset.carousel === 'true';

  initPins(section);
  section.querySelectorAll('.hotspot-card-form').forEach(initCardForm);

  if (isCarousel) initCarousel(section, cols);
}

function initCardForm(form) {
  const card = form.closest('.hotspot-card, .stl-pack-card');
  const idInput = form.querySelector('.selected-variant-id');
  const addBtn = form.querySelector('.hotspot-card-add');
  const addText = form.querySelector('.hotspot-card-add-text');
  const spinner = addBtn.querySelector('.loading__spinner');
  const errorEl = form.querySelector('.hotspot-card-error');
  const colorLabel = form.querySelector('.hotspot-option-selected');

  const activeSizes = () => form.querySelector('.hotspot-sizes:not([hidden])');

  function setButtonState() {
    const sizes = activeSizes();
    const hasAvailable = sizes && sizes.querySelector('.variant-button:not(.unavailable)');

    addBtn.disabled = !idInput.value;
    if (idInput.value) {
      addText.textContent = addBtn.dataset.labelAdd;
    } else {
      addText.textContent = hasAvailable ? addBtn.dataset.labelSelect : addBtn.dataset.labelSoldOut;
    }
  }

  function selectSize(button) {
    activeSizes()
      ?.querySelectorAll('.variant-button')
      .forEach((btn) => btn.classList.toggle('selected', btn === button));
    idInput.value = button.dataset.variantId;
    if (errorEl) errorEl.hidden = true;
    setButtonState();
  }

  function selectColor(swatch) {
    form.querySelectorAll('.hotspot-color-swatch').forEach((s) => {
      const isActive = s === swatch;
      s.classList.toggle('select_variant', isActive);
      s.setAttribute('aria-pressed', String(isActive));
    });

    form.querySelectorAll('.hotspot-sizes').forEach((group) => {
      group.hidden = group.dataset.panel !== swatch.dataset.panel;
    });

    // Al cambiar de color se reinicia la talla, salvo que sea talla única
    const sizes = activeSizes();
    const buttons = sizes ? [...sizes.querySelectorAll('.variant-button')] : [];
    buttons.forEach((btn) => btn.classList.remove('selected'));
    idInput.value = '';
    if (buttons.length === 1 && !buttons[0].classList.contains('unavailable')) {
      selectSize(buttons[0]);
    }

    if (colorLabel) colorLabel.textContent = swatch.dataset.color || '';

    const { price, comparePrice, image, url, title } = swatch.dataset;
    const priceEl = card.querySelector('.hotspot-card-price-current');
    const compareEl = card.querySelector('.hotspot-card-price-compare');
    if (priceEl && price) priceEl.textContent = price;
    if (compareEl) {
      compareEl.hidden = !comparePrice;
      compareEl.textContent = comparePrice || '';
    }

    const img = card.querySelector('.hotspot-card-img');
    if (img && image) {
      img.removeAttribute('srcset');
      img.src = image;
    }

    const titleEl = card.querySelector('.hotspot-card-title');
    if (titleEl && title) titleEl.textContent = title;
    if (url) {
      card.querySelectorAll('.hotspot-card-img-link, .hotspot-card-title').forEach((link) => {
        link.href = url;
      });
    }

    if (errorEl) errorEl.hidden = true;
    setButtonState();
  }

  form.addEventListener('click', (e) => {
    const sizeBtn = e.target.closest('.variant-button');
    if (sizeBtn && !sizeBtn.disabled) {
      selectSize(sizeBtn);
      return;
    }
    const swatch = e.target.closest('.hotspot-color-swatch');
    if (swatch && !swatch.disabled) selectColor(swatch);
  });

  setButtonState();

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (addBtn.disabled || !idInput.value) return;

    if (form.dataset.mode === 'pack') {
      const sizes = activeSizes();
      const size = sizes?.querySelector('.variant-button.selected');
      const titleEl = card.querySelector('.hotspot-card-title');
      const img = card.querySelector('.hotspot-card-img');
      form.dispatchEvent(
        new CustomEvent('stl:pack-choose', {
          bubbles: true,
          detail: {
            variantId: idInput.value,
            title: titleEl?.textContent.trim() || '',
            url: titleEl?.href || '',
            image: img?.currentSrc || img?.src || '',
            color: colorLabel?.textContent.trim() || '',
            size: sizes && sizes.querySelectorAll('.variant-button').length > 1 ? size?.textContent.trim() || '' : '',
            price: parseInt(size?.dataset.price || '0', 10),
          },
        })
      );
      return;
    }

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const formData = new FormData();
    formData.append('id', idInput.value);
    formData.append('quantity', 1);

    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    addBtn.disabled = true;
    addBtn.classList.add('loading');
    spinner?.classList.remove('hidden');

    fetch(`${window.routes.cart_add_url}`, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status) {
          if (errorEl) {
            errorEl.textContent = response.description || response.message;
            errorEl.hidden = false;
          }
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'hotspot-card',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }

        const section = form.closest('.hotspot-looks-section');
        if (section) closeAllCards(section);
        cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        addBtn.classList.remove('loading');
        spinner?.classList.add('hidden');
        setButtonState();
      });
  });
}

function initPins(section) {
  section.querySelectorAll('.hotspot-pin:not([data-pack-pin])').forEach((pin) => {
    pin.addEventListener('click', (e) => {
      e.stopPropagation();
      const id = pin.dataset.pinId;
      const card = section.querySelector(`#${id}`);
      const isOpen = pin.getAttribute('aria-expanded') === 'true';

      closeAllCards(section);

      if (!isOpen && card) {
        openCard(pin, card);
      }
    });
  });

  section.querySelectorAll('.hotspot-card-close').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const card = btn.closest('.hotspot-card');
      if (!card) return;
      const pin = section.querySelector(`[data-pin-id="${card.id}"]`);
      closeCard(pin, card);
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.hotspot-look-image-wrapper')) {
      closeAllCards(section);
    }
  });
}

function openCard(pin, card) {
  pin.setAttribute('aria-expanded', 'true');
  card.removeAttribute('hidden');
  positionCard(pin, card);
}

function closeCard(pin, card) {
  if (card) card.setAttribute('hidden', '');
  if (pin) pin.setAttribute('aria-expanded', 'false');
}

function closeAllCards(section) {
  section.querySelectorAll('.hotspot-pin[aria-expanded="true"]:not([data-pack-pin])').forEach((p) => {
    const id = p.dataset.pinId;
    const c = id ? section.querySelector(`#${id}`) : null;
    closeCard(p, c);
  });
}

function positionCard(pin, card) {
  const wrapper = pin.closest('.hotspot-look-image-wrapper');
  if (!wrapper) return;

  const wRect = wrapper.getBoundingClientRect();
  const pinX = parseFloat(pin.style.left) / 100;
  const pinY = parseFloat(pin.style.top) / 100;

  const cardW = card.offsetWidth || 280;
  const cardH = card.offsetHeight || 130;
  const offset = 22;

  const placeRight = pinX < 0.6;
  const placeBelow = pinY < 0.45;

  const pinPxX = pinX * wRect.width;
  const pinPxY = pinY * wRect.height;

  let left = placeRight ? pinPxX + offset : pinPxX - cardW - offset;
  let top = placeBelow ? pinPxY + offset : pinPxY - cardH - offset;

  left = Math.max(4, Math.min(left, wRect.width - cardW - 4));
  top = Math.max(4, Math.min(top, wRect.height - cardH - 4));

  card.style.left = `${left}px`;
  card.style.top = `${top}px`;
}

function initCarousel(section, cols) {
  const wrapper = section.querySelector('.hotspot-looks-wrapper');
  const track = section.querySelector('.hotspot-looks-track');
  const prevBtn = wrapper.querySelector('.hotspot-prev');
  const nextBtn = wrapper.querySelector('.hotspot-next');
  const dotsContainer = wrapper.querySelector('.hotspot-dots');
  const items = [...section.querySelectorAll('.hotspot-look-item')];

  let currentPage = 0;
  const totalPages = Math.ceil(items.length / cols);

  buildDots();
  updateCarousel();

  prevBtn?.addEventListener('click', () => go(currentPage - 1));
  nextBtn?.addEventListener('click', () => go(currentPage + 1));

  initSwipe(wrapper.querySelector('.hotspot-looks-overflow'));

  function go(index) {
    currentPage = Math.max(0, Math.min(index, totalPages - 1));
    closeAllCards(section);
    updateCarousel();
  }

  function updateCarousel() {
    if (!track || items.length === 0) return;

    const itemWidth = items[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(track).gap) || 32;
    const offset = currentPage * (itemWidth + gap) * cols;

    track.style.transform = `translateX(-${offset}px)`;

    if (prevBtn) prevBtn.disabled = currentPage === 0;
    if (nextBtn) nextBtn.disabled = currentPage === totalPages - 1;

    dotsContainer?.querySelectorAll('.hotspot-dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === currentPage);
      dot.setAttribute('aria-selected', String(i === currentPage));
    });
  }

  function buildDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement('button');
      dot.className = 'hotspot-dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Look ${i + 1}`);
      dot.addEventListener('click', () => go(i));
      dotsContainer.appendChild(dot);
    }
  }

  function initSwipe(el) {
    if (!el) return;
    let startX = 0;

    el.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) go(currentPage + (diff > 0 ? 1 : -1));
    }, { passive: true });
  }
}

if (!customElements.get('stl-pack')) {
  customElements.define(
    'stl-pack',
    class StlPack extends HTMLElement {
      connectedCallback() {
        this.look = this.closest('.hotspot-look-item');
        this.pins = [...this.look.querySelectorAll('[data-pack-pin]')];
        this.drawer = document.getElementById(this.dataset.drawer);
        this.list = this.querySelector('[data-pack-list]');
        this.count = this.querySelector('[data-pack-count]');
        this.emptyText = this.querySelector('[data-pack-empty]');
        this.footer = this.querySelector('[data-pack-footer]');
        this.total = this.querySelector('[data-pack-total]');
        this.addButton = this.querySelector('[data-pack-add]');
        this.error = this.querySelector('[data-pack-error]');
        this.strings = this.readStrings();
        this.selection = new Map();

        this.pins.forEach((pin) =>
          pin.addEventListener('click', (event) => {
            event.stopPropagation();
            this.openDrawer(pin);
          })
        );
        this.list.addEventListener('click', this.onListClick.bind(this));
        this.addButton.addEventListener('click', this.addToCart.bind(this));
        this.render();
      }

      readStrings() {
        try {
          return JSON.parse(this.querySelector('[data-pack-strings]')?.textContent || '{}');
        } catch {
          return {};
        }
      }

      openDrawer(pin) {
        if (!this.drawer) return;
        const section = this.closest('.hotspot-looks-section');
        if (section) closeAllCards(section);
        pin.setAttribute('aria-expanded', 'true');
        this.drawer.open({
          url: pin.dataset.collectionUrl,
          title: pin.dataset.collectionTitle,
          opener: pin,
          onChoose: (item) => this.choose(pin, item),
          onClose: () => pin.setAttribute('aria-expanded', 'false'),
        });
      }

      choose(pin, item) {
        this.selection.set(pin.dataset.packPin, item);
        this.syncPin(pin, item);
        this.error.hidden = true;
        this.render();
      }

      remove(pin) {
        this.selection.delete(pin.dataset.packPin);
        this.syncPin(pin, null);
        this.render();
      }

      syncPin(pin, item) {
        pin.classList.toggle('is-filled', Boolean(item));
        const thumb = pin.querySelector('[data-pack-pin-thumb]');
        if (!thumb) return;
        thumb.hidden = !item?.image;
        if (item?.image) thumb.src = item.image;
      }

      onListClick(event) {
        const button = event.target.closest('[data-pack-action]');
        if (!button) return;
        const pin = this.pins.find((item) => item.dataset.packPin === button.dataset.pin);
        if (!pin) return;
        if (button.dataset.packAction === 'change') {
          this.openDrawer(pin);
        } else {
          this.remove(pin);
        }
      }

      selectedItems() {
        return this.pins
          .filter((pin) => this.selection.has(pin.dataset.packPin))
          .map((pin) => ({ key: pin.dataset.packPin, item: this.selection.get(pin.dataset.packPin) }));
      }

      escapeHtml(value) {
        const div = document.createElement('div');
        div.textContent = value == null ? '' : String(value);
        return div.innerHTML;
      }

      formatMoney(cents) {
        const amount = Math.round(cents / 100).toLocaleString('es-CL');
        return (this.dataset.moneyFormat || '${{amount}}').replace(/\{\{\s*[\w_]+\s*\}\}/g, amount);
      }

      render() {
        const selected = this.selectedItems();
        const total = selected.reduce((sum, { item }) => sum + item.price, 0);

        this.list.innerHTML = selected
          .map(({ key, item }) => {
            const meta = [item.color, item.size].filter(Boolean).join(' · ');
            return `
              <li class="stl-pack__item">
                ${item.image ? `<img class="stl-pack__thumb" src="${this.escapeHtml(item.image)}" alt="" width="56" height="56" loading="lazy">` : ''}
                <div class="stl-pack__info">
                  <a class="stl-pack__name" href="${this.escapeHtml(item.url)}">${this.escapeHtml(item.title)}</a>
                  ${meta ? `<span class="stl-pack__meta">${this.escapeHtml(meta)}</span>` : ''}
                  <span class="stl-pack__actions">
                    <button type="button" class="stl-pack__action" data-pack-action="change" data-pin="${key}">${this.escapeHtml(this.strings.change)}</button>
                    <button type="button" class="stl-pack__action" data-pack-action="remove" data-pin="${key}">${this.escapeHtml(this.strings.remove)}</button>
                  </span>
                </div>
                <span class="stl-pack__price">${this.formatMoney(item.price)}</span>
              </li>`;
          })
          .join('');

        this.count.textContent = (this.strings.count || '')
          .replace('[count]', selected.length)
          .replace('[total]', this.pins.length);
        this.emptyText.hidden = selected.length > 0;
        this.footer.hidden = selected.length === 0;
        this.total.textContent = this.formatMoney(total);
        this.addButton.disabled = selected.length === 0;
      }

      setLoading(loading) {
        this.addButton.disabled = loading;
        this.addButton.classList.toggle('loading', loading);
        this.addButton.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
      }

      showError(message) {
        this.error.textContent = message || this.strings.error;
        this.error.hidden = false;
      }

      async addToCart() {
        const selected = this.selectedItems();
        if (!selected.length) return;

        const cart = document.querySelector('cart-drawer');
        const body = { items: selected.map(({ item }) => ({ id: Number(item.variantId), quantity: 1 })) };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement(this.addButton);
        }

        this.error.hidden = true;
        this.setLoading(true);

        try {
          const response = await fetch(window.routes.cart_add_url, { ...fetchConfig('javascript'), body: JSON.stringify(body) });
          const data = await response.json();
          if (data.status) {
            this.showError(data.description || data.message);
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'stl-pack', cartData: data });
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.pins.forEach((pin) => this.syncPin(pin, null));
          this.selection.clear();
          this.render();
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } catch {
          this.showError();
        } finally {
          this.setLoading(false);
          this.addButton.disabled = this.selection.size === 0;
        }
      }
    }
  );
}
